'use client'

import { useRef } from "react";

export const useVideoRef = () => {
    const videoRef = useRef<HTMLVideoElement>(null);

    return videoRef;
}